import siteConfig from "../config/siteConfig";

export const toNumber = (value, fallback = 0) => {
  const parsed = typeof value === "number" ? value : Number(value);
  return Number.isFinite(parsed) ? parsed : fallback;
};

export const formatCurrency = (
  value,
  {
    currency = siteConfig.currency,
    locale = siteConfig.locale,
    minimumFractionDigits = 0,
    maximumFractionDigits = 0,
  } = {}
) =>
  new Intl.NumberFormat(locale, {
    style: "currency",
    currency,
    minimumFractionDigits,
    maximumFractionDigits,
  }).format(toNumber(value));

export const formatDate = (value, locale = siteConfig.locale) => {
  const date = value instanceof Date ? value : new Date(value);

  if (Number.isNaN(date.getTime())) return "";

  return new Intl.DateTimeFormat(locale, {
    day: "numeric",
    month: "long",
    year: "numeric",
  }).format(date);
};

export const slugify = (value = "") =>
  value
    .toString()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/(^-|-$)/g, "");

export const formatStockMessage = (stock) => {
  const quantity = Math.max(0, Math.floor(toNumber(stock)));

  if (quantity === 0) return "Sold out";
  if (quantity <= 5) return `Only ${quantity} left`;
  return "In stock";
};
